import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import List from  '@material-ui/core/List';
import ListItem from  '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Header from './../Header';
import Footer from './../Footer';
import { Link, Redirect } from 'react-router-dom';
import { loadInspectorNotifications, loadAppeals, searchConclusion, searchConclusions, logout} from "./../../actions/actions";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import NotificationList from './../lists/NotificationList';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import OldBrowserMessage from './../OldBrowserMessage';

const rows = [
    { id: 'id', numeric: true, disablePadding: false, label: '' },
    { id: 'expertise_resolution_index',numeric: false, disablePadding: false, label: '№ Заключения' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Статус' },
    { id: 'kind', numeric: false, disablePadding: false, label: 'Тип' },
    { id: 'last_edited_date', numeric: false, disablePadding: false, label: 'Дата последнего редактирования' },
    { id: 'object_name', numeric: false, disablePadding: false, label: 'Наименование объекта' },
    { id: 'registration_number', numeric: false, disablePadding: false, label: '№ объекта' },
    { id: 'reply_number', numeric: false, disablePadding: false, label: '№ исходящий' },
    { id: 'inspection', numeric: false, disablePadding: false, label: 'Инспекция' },
    { id: 'draft_url', numeric: false, disablePadding: false, label: '' },
    { id: 'signed_url', numeric: false, disablePadding: false, label: '' },
];


const attributes = {
    id:'Открыть',
    expertise_resolution_index: '№ Заключения',
    status:'Статус',
    state:'Состояние',
    kind:'Тип',
    submitted_date:'Дата создания',
    object_name: 'Наименование объекта',
    registration_number:'№ объекта',
    notification_reply_number:'№ исходящего',
    inspection_name:'Инспекция',
    doc:'PDF'
}

const styles = {
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
};

export class SupervisionPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            search:'',
            redirect: null,
            user: {},
            auth: false,
            notifications: [],
            conclusions:[],
            notification: {}
        }
    }
    logout = () => {
        this.props.logout();
        this.setState({auth:false, user:{}, redirect:null});
    }

    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user !== null) {
            if (user.role.indexOf('ROLE_SUPERVISOR')>=0) {
                this.setState({auth: true, user: user});
                this.props.loadNotifications(user.token);
                this.props.loadAppeals(user.token);
                
            }
        }
    }

    componentWillReceiveProps(nextProps)
    {
        console.log('PROPS');
        if (!!Object.keys(nextProps.conclusions).length) {
                this.setState({conclusions: nextProps.conclusions})
        }
    }

    updateInput = input => {
        this.setState({search: input.value});
    }

    handleSearch = () => {
        this.props.searchConclusion(this.state.search);
    }

    toggleDrawer = (side, open) => () => {
        this.setState({
            [side]: open,
        });
    };

    render(){
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        let {notifications, conclusions } = this.props;
        let conclusionList = conclusions.length > 0 ? (<Paper><List>
            {conclusions.map(item => (<ListItem key={conclusions.indexOf(item)}><a target="_blank" key={conclusions.indexOf(item)} href={`/pds/${item}`}>{item}</a></ListItem>))}</List></Paper>): <Paper />

        let list = notifications.length > 0 ?
             <NotificationList rows={rows} items={notifications} title="Уведомления" openLink="notification-card"/>:
            <p> В архиве уведомлений нет</p>
        return (
        <div>    
        <Paper>
            <Header link={{to:'/inspection/', title: this.state.user.org}} />
            <Toolbar>
                <Button component={Link} to="/supervision/">Уведомления</Button>
                <Button component={Link} to="/admin-objects">Поднадзорные объекты</Button>
                {/*<Button component={Link} to="/inspection-appeals">Электронные обращения</Button>*/}
                <Button component={Link} to="/manage-account/">Личный профиль</Button>
                <Button component={Link} to="/conclusions/">Заключения</Button>
                <Button onClick={this.toggleDrawer('right', true)}>ПСД</Button>
                <Button onClick={this.logout}>Выйти</Button>
            </Toolbar>
            <OldBrowserMessage />
             {list}
            <SwipeableDrawer
                anchor="right"
                swipeAreaWidth={this.state.swipeWidth}
                open={this.state.right}
                onClose={this.toggleDrawer('right', false)}
                onOpen={this.toggleDrawer('right', true)}
            >
                <div
                    tabIndex={0}
                >
                    <TextField
                        style={{width: "200px", marginLeft:"1em"}}
                        label="Поиск по ПСД" onChange={e => this.updateInput(e.target)}></TextField>
                    <Button style={{marginTop:"1em"}} onClick={this.handleSearch}>Искать</Button>
                    <Button style={{marginTop:"1em"}} onClick={this.toggleDrawer('right', false)}>Закрыть</Button>
                    {conclusionList}
                </div>
            </SwipeableDrawer>
        </Paper>
            <Footer />
        </div>
            );
    }
}

function select(state, props) {
    const { notifications, inspector } = state;
    console.log('SELECT');
    return {
        notifications: (typeof notifications !== "undefined" && 'data' in notifications) ? notifications.data : [],
        notification: (typeof notifications !== "undefined" && 'item' in notifications) ?  notifications.item : {},
        conclusion: (typeof inspector !== "undefined" && 'conclusions' in inspector) ?  inspector.conclusions : {},
        conclusions: (typeof inspector !== "undefined" && 'conclusions' in inspector) ? inspector.conclusions : {},
        reply: (typeof notifications !== "undefined" && 'reply' in notifications) ?  notifications.item : {},
        
    };
}

SupervisionPage.defaultProps = {
    conclusions: [],
    notifications: [],
    redirect: null
}


function mapDispatch(dispatch) {
    return {
        loadNotifications: bindActionCreators(loadInspectorNotifications, dispatch),
        searchConclusion: bindActionCreators(searchConclusion, dispatch),
        searchConclusions: bindActionCreators(searchConclusions, dispatch),
        loadAppeals: bindActionCreators(loadAppeals, dispatch),
        logout:bindActionCreators(logout, dispatch)
    };
}


export default connect(select, mapDispatch)(SupervisionPage);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/SupervisionPage.jsx